import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TextModes } from '../inputs/textbox/textbox';

interface AuthSettingsResponse {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  usesPasswordAuth: boolean;
  usesGoogleAuth: boolean;
}

@Component({
  selector: 'app-profile-form',
  standalone: false,
  templateUrl: './profile-form.html',
})
export class ProfileForm {
  @Input() suiteUrl: string = '';
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  userProfile: AuthSettingsResponse | null = null
  cachedUserProfile: AuthSettingsResponse | null = null;
  currentPassword: string = '';
  newPassword: string = '';
  confirmNewPassword: string = '';

  usesPasswordAuth: boolean = false;
  usesGoogleAuth: boolean = false;

  InputTextModes = TextModes;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    console.log('ProfileForm ngOnInit');
    // load the profile from the session
    // ...

    if (!this.suiteUrl) {
      console.error('ProfileForm: suiteUrl input is required');
      return;
    }

    this.http
      .get<AuthSettingsResponse>(`${this.suiteUrl}/api/auth/auth-settings`, {
        withCredentials: true,
      })
      .subscribe({
        next: (response) => {
          this.userProfile = {...response}
          this.cachedUserProfile = response
          this.usesPasswordAuth = response.usesPasswordAuth;
          this.usesGoogleAuth = response.usesGoogleAuth;
        },
        error: (err) => {
          console.error('Failed to load auth settings', err);
        },
      });
  }

  btnCancelProfileClick() {
    this.userProfile = { ...this.cachedUserProfile as AuthSettingsResponse }
    this.onClose.emit();
  }

  btnSaveProfileClick() {
    const profile = {
      firstName: this.userProfile?.firstName,
      lastName: this.userProfile?.lastName,
      phone: this.userProfile?.phone,
    }
    console.log(profile);
    this.http
      .put(
        `${this.suiteUrl}/api/user/profile`,
        profile,
        {
          withCredentials: true,
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
        },
      )
      .subscribe((response) => {
        if (!response) {
        }
        this.onClose.emit();
      });
  }

  btnCancelPasswordClick() {
    
  }

  btnSavePasswordClick() {
    if (this.newPassword !== this.confirmNewPassword) {
      console.log('Passwords do not match');
      return;
    }

    this.http
      .put(
        `${this.suiteUrl}/api/auth/change-password`,
        {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        },
        {
          withCredentials: true,
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
        },
      )
      .subscribe((response) => {
        console.log(response);
      });
  }
}
